import './App.css';
import 'bootstrap/dist/css/bootstrap.css';

import { useState } from "react";

import { Intro } from "./sections/Intro";
import { Material, } from "./sections/Material";
import { Content } from "./extra/Components";

import { Faltet } from './sections/Faltet';
import { Hoppet } from './sections/Hoppet';
import { UnderSkarm } from './sections/Underskarm';
import { Felfunktioner } from './sections/Felfunkioner';
import { Landning } from './sections/Landning';
import { Packning } from './sections/Packning';
import { Aff } from './sections/Aff';
import { StorQuiz } from './sections/Storquiz';
import ALicens from './sections/Alicens';
import Vidare from './sections/Vidare';

import { useParams, useNavigate } from 'react-router-dom';
import { SydUspa } from './SydUspa';
import { SydKort } from './SydKort';


function App() {
    let params = useParams();
    var club = params.club ?? "syd";
    var article = params.article;

    const navigate = useNavigate();
    var setClub = (e) => navigate('/' + e);
    var setArticle = (e) => navigate('/' + club + "/" + e);

    const [section, setSection] = useState(null);
    const targets = { setSection: setSection, setArticle: setArticle }

    switch (params.club) {
        case "syd":
        case undefined:
            return (
                <Content section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub}>
                    {Intro(targets)}
                    {Material(targets)}
                    {Faltet(targets)}
                    {Hoppet(targets)}
                    {UnderSkarm(targets)}
                    {Felfunktioner(targets)}
                    {Landning(targets)}
                    {Packning(targets)}
                    {Aff(targets)}
                    {StorQuiz(targets)}
                    {ALicens(targets)}
                    {Vidare(targets)}
                </Content>);
        case "sydLong":
            return (
                <Content section={section} article={article} setArticle={setArticle} oneBig={true} club={club} setClub={setClub}>
                    {Intro(targets)}
                    {Material(targets)}
                    {Faltet(targets)}
                    {Hoppet(targets)}
                    {UnderSkarm(targets)}
                    {Felfunktioner(targets)}
                    {Landning(targets)}
                    {Packning(targets)}
                    {Aff(targets)}
                    {StorQuiz(targets)}
                    {ALicens(targets)}
                    {Vidare(targets)}
                </Content>
            )
        case "sydKort":
            return (
                <SydKort section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub} setSection={setSection} targets={targets} />
            )
        case "sydUspa":
            return (
                <SydUspa section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub} setSection={setSection} targets={targets} />
            )
        default:
            return <p>Något gick väldigt fel i att välja klubb</p>
    }
}



export default App;
